<app-lfsa-card [innTemplate]="requisicion" [titulo]="'BUSCAR'" [efecto]="true" [colapseName]="'requisicion'"
  [banderaColapse]='true'></app-lfsa-card>
<ng-template #requisicion>
  <form [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div [class]="'col-md-4'">
        <app-lfsa-combo-box (change)="getData($event)" [claseLabel]="'letrasDanger'" [opcion]="'descripcion'"
          [idOpcion]="'codEmpresa'" [comboBox]="cmbEmpresas" formControlName="codigoEmpresa"
          [control]="formulario.get('codigoEmpresa')" [label]="'Empresas*'" [id]="'empresa'">
        </app-lfsa-combo-box>
      </div>

    </div>
  </form>
  <br>
</ng-template>

<app-lfsa-card *ngIf="mostrarCard" [innTemplate]="datosRequisicion" [titulo]="'DATOS DE CONSULTA'" [efecto]="true"
  [colapseName]="'datosRequisicion'" [banderaColapse]='true'></app-lfsa-card>
<ng-template #datosRequisicion>

  <div class="row" *ngIf="!listaVacia">
    <div [class]="'col-md-10'">
      <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscar" id="quickFilter "
        (keyup)="onQuickFilterChanged() " #quickFilter />
    </div>
    <div [class]="'col-md-2'"> <!--descomentar para la nueva version-->
      <button (click)="callModalMultiple()" [disabled]="selectedRowsEdit.length === 0"
        [class]="classEdit">Editar</button>
    </div>
  </div>

  <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
  <div *ngIf="!loading">
    <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
      No existen datos para la lista de Reporte.
    </div>
    <ag-grid-angular *ngIf="!listaVacia" #agGrid class=" {{empModulo.agGrid.class}}" 
      [ngStyle]="empModulo.agGrid.style" id="{{empModulo.agGrid.id}}" [frameworkComponents]="frameworkComponents "
      [columnDefs]="columnDefs" (selectionChanged)="onSelectionChanged()" [rowSelection]="rowSelection"
      [rowData]="rowData" (gridReady)="onGridReady($event)" [pagination]="true"
      [paginationPageSize]="empModulo.agGrid.paginacion">
    </ag-grid-angular>
  </div>
  <br>
</ng-template>

<app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
<div *ngIf="!loading" class="row">
  <div class="form-group col-md-12">
    <button [routerLink]="['/emp/administrador/home-emp']"
      class="btn btn-outline-danger btn-block btn-lg">Regresar</button>
  </div>
</div>


<!-- </div> -->
<!-- </div> -->

<!-- MODAL -->
<app-lfsa-modal [innTemplate]="enviarModal" [titulo]="'Crear Historial'" [idButton]="'abrirModal'" [idOpen]="'Modal'"
  [idClose]="'cerrarModal'"></app-lfsa-modal>
<ng-template #enviarModal>
  <form [formGroup]="formularioEmp" novalidate class="form-group">
    <div class="row">
      <div [class]="'col-md-6'">
        <h5> <b>Nombres:</b>&nbsp; {{ EmpleadoModal.nombres }} </h5>
      </div>
      <div [class]="'col-md-6'">
        <h5><b>C.C:</b>&nbsp; {{ EmpleadoModal.cedula }} </h5>
      </div>
    </div>
    <hr>
    <div class="row">
      <div [class]="'form-group col-md-4'">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [mostrarImg]="false" [rutaImagen]=""
          [control]="formularioEmp.get('fechaIngreso')" [placeholder]="'Ingrese Fecha Ingreso'"
          formControlName="fechaIngreso" [label]="'Fecha Ingreso*'" [type]="'date'" [id]="'fechaIngreso'">
        </app-lfsa-input>
      </div>
      <div [class]="'form-group col-md-4'">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [mostrarImg]="false" [rutaImagen]=""
          [control]="formularioEmp.get('fechaSalida')" [placeholder]="'Ingrese Fecha Salida'"
          formControlName="fechaSalida" [label]="'Fecha Salida*'" [type]="'date'" [id]="'fechaSalida'">
        </app-lfsa-input>
      </div>
      <!-- <div class="form-group col-md-4">
        <app-combo-box [claseLabel]="'letrasDanger'"
              [opcion]="'clave'" [idOpcion]="'valor'" [comboBox]="cmbAccesoIESS" formControlName="accesoIESS"
              [control]="formularioEmp.get('accesoIESS')" [label]="'Acceso IESS*'" [id]="'accesoIESS'" >
        </app-combo-box>
      </div> -->
      <div class="form-group col-md-3">
        <label>Doc.IESS</label><br>
        <input id="docIess" type="checkbox" (click)="setCheckForm(formularioEmp.get('accesoIESS').value)"/>&nbsp;
        <span>{{ statusCheck }}</span>
      </div> 
      <div class="form-group col-md-4">
        <app-lfsa-combo-box (change)='selecionEmpresaSolicita()' [claseLabel]="'letrasDanger'"
          (change)="changeClearSolicitados($event)" [opcion]="'descripcion'" [idOpcion]="'codEmpresa'"
          [comboBox]="cmbEmpresaSolicita" formControlName="empresaSolicita"
          [control]="formularioEmp.get('empresaSolicita')" [label]="'Empresa Solicitante*'" [id]="'empresaSolicita'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-md-4" (dblclick)="clearCmb('departamentoSolicita')">
        <app-lfsa-combo-box (change)='selecionDepartamentoSolicita()' (change)="changeClearEmpleado()"
          [opcion]="'descripcion'" [claseLabel]="'letrasDanger'" [idOpcion]="'id'" [comboBox]="cmbDepartamentoSolicita"
          formControlName="departamentoSolicita" [control]="formularioEmp.get('departamentoSolicita')"
          [label]="'Departamento Solicita*'" [id]="'departamentoSolicita'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-md-4" (dblclick)="clearCmb('empleadoSolicita')">
        <app-lfsa-combo-box [opcion]="'nombres'" [claseLabel]="'letrasDanger'" [idOpcion]="'cedula'"
          [comboBox]="cmbEmpleadoSolicita" formControlName="empleadoSolicita"
          [control]="formularioEmp.get('empleadoSolicita')" [label]="'Empleado Solicitante'" [id]="'empleadoSolicita'">
        </app-lfsa-combo-box>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
        <div *ngIf="!loading">
          <label>&nbsp;</label><br>
          <button class="btn btn-success btn-block" [disabled]="formularioEmp.invalid"
            (click)="updateEmpleado()">Guardar</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<!-- MODAL MULTIPLE -->
<!-- MODAL -->
<app-lfsa-modal [innTemplate]="abrirModalMuiltiples" [titulo]="'Crear Historial Multiple'"
  [idButton]="'abrirModalMuiltiple'" [idOpen]="'ModalMultiple'" [idClose]="'cerrarModalMultiple'"></app-lfsa-modal>
<ng-template #abrirModalMuiltiples>
  <form [formGroup]="formularioEmpMultiple" novalidate class="form-group">
    <div class="row">
      <div [class]="'form-group col-md-4'">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [mostrarImg]="false" [rutaImagen]=""
          [control]="formularioEmpMultiple.get('fechaIngreso')" [placeholder]="'Ingrese Fecha Ingreso'"
          formControlName="fechaIngreso" [label]="'Fecha Ingreso*'" [type]="'date'" [id]="'fechaIngreso'">
        </app-lfsa-input>
      </div>
      <div [class]="'form-group col-md-4'">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [mostrarImg]="false" [rutaImagen]=""
          [control]="formularioEmpMultiple.get('fechaSalida')" [placeholder]="'Ingrese Fecha Salida'"
          formControlName="fechaSalida" [label]="'Fecha Salida*'" [type]="'date'" [id]="'fechaSalida'">
        </app-lfsa-input>
      </div>
      <!-- <div class="form-group col-md-4">
        <app-combo-box [claseLabel]="'letrasDanger'"
              [opcion]="'clave'" [idOpcion]="'valor'" [comboBox]="cmbAccesoIESS" formControlName="accesoIESS"
              [control]="formularioEmpMultiple.get('accesoIESS')" [label]="'Acceso IESS*'" [id]="'accesoIESS'" >
        </app-combo-box>
      </div> -->
      <div class="form-group col-md-3">
        <label>Doc.IESS</label><br>
        <input id="docIessMul" type="checkbox" (click)="setCheckFormMul(formularioEmpMultiple.get('accesoIESS').value)"/>&nbsp;
        <span>{{ statusCheckMul }}</span>
      </div> 
      <div class="form-group col-md-4">
        <app-lfsa-combo-box (change)='selecionEmpresaSolicitaMul()' [claseLabel]="'letrasDanger'"
          (change)="changeClearSolicitadosMul($event)" [opcion]="'descripcion'" [idOpcion]="'codEmpresa'"
          [comboBox]="cmbEmpresaSolicita" formControlName="empresaSolicita"
          [control]="formularioEmpMultiple.get('empresaSolicita')" [label]="'Empresa Solicitante*'"
          [id]="'empresaSolicita'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-md-4" (dblclick)="clearCmbMul('departamentoSolicita')">
        <app-lfsa-combo-box (change)='selecionDepartamentoSolicitaMul()' (change)="changeClearEmpleadoMul()"
          [opcion]="'descripcion'" [claseLabel]="'letrasDanger'" [idOpcion]="'id'" [comboBox]="cmbDepartamentoSolicita"
          formControlName="departamentoSolicita" [control]="formularioEmpMultiple.get('departamentoSolicita')"
          [label]="'Departamento Solicita*'" [id]="'departamentoSolicita'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-md-4" (dblclick)="clearCmbMul('empleadoSolicita')">
        <app-lfsa-combo-box [opcion]="'nombres'" [claseLabel]="'letrasDanger'" [idOpcion]="'cedula'"
          [comboBox]="cmbEmpleadoSolicita" formControlName="empleadoSolicita"
          [control]="formularioEmpMultiple.get('empleadoSolicita')" [label]="'Empleado Solicitante'"
          [id]="'empleadoSolicita'">
        </app-lfsa-combo-box>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
        <div *ngIf="!loading">
          <label>&nbsp;</label><br>
          <button class="btn btn-success btn-block" [disabled]="formularioEmpMultiple.invalid"
            (click)="updateEmpleadoMultiple()">Guardar</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>
<!-- {{ rowData | json }} -->
<br>